import { render, staticRenderFns } from "./block-reasons-for-rental.vue?vue&type=template&id=29d63cb8&scoped=true&"
import script from "./block-reasons-for-rental.vue?vue&type=script&lang=js&"
export * from "./block-reasons-for-rental.vue?vue&type=script&lang=js&"
import style0 from "./block-reasons-for-rental.vue?vue&type=style&index=0&id=29d63cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d63cb8",
  null
  
)

export default component.exports